import { render, staticRenderFns } from "./PublicationDetails.vue?vue&type=template&id=6302c656"
import script from "./PublicationDetails.vue?vue&type=script&lang=ts"
export * from "./PublicationDetails.vue?vue&type=script&lang=ts"
import style0 from "./PublicationDetails.vue?vue&type=style&index=0&id=6302c656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports